import { HttpNoData } from "../Core";

export async function getFormulaAmounts(date, jwt) {

    const response = await HttpNoData(`/api/v1/formulas/amounts/${date}`, 'GET', jwt);

    return response.data;
}
export async function ProductOnDate(timeSpan, date, jwt, placeIds = []) {
    const params = new URLSearchParams();
    if (date) params.append('date', date);

    // Добавляем placeIds в параметры
    placeIds.forEach(id => {
        params.append('placeIds', id.toString());
    });

    const response = await HttpNoData(
        `/api/v0/analyze/products/${timeSpan}?${params.toString()}`,
        'GET',
        jwt
    );

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}

export async function ProductOnDateRange(timeSpan, startDate, endDate, jwt, placeIds = []) {
    // Создаем параметры запроса
    const params = new URLSearchParams();
    params.append('start', startDate);
    params.append('end', endDate);

    // Добавляем placeIds в параметры
    placeIds.forEach(id => {
        params.append('placeIds', id.toString());
    });

    const response = await HttpNoData(
        `/api/v0/analyze/products/range/${timeSpan}?${params.toString()}`,
        'GET',
        jwt
    );

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}

export async function getDataDay(dateDay, jwt) {

    const response = await HttpNoData('/api/v0/analyze/leads/' + dateDay, 'GET', jwt);

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}

export async function getPlaces(jwt) {
    const response = await HttpNoData('/api/v0/analyze/places', 'GET', jwt);

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}


//SendsAnalyzeController

export async function NewProductOnDate(timeSpan, date, jwt, placeIds = [], productType = null, useCoefficient = false) {
    const params = new URLSearchParams();
    if (date) params.append('date', date);

    placeIds.forEach(id => {
        params.append('placeIds', id.toString());
    });
    if (productType !== null) params.append('productType', productType);
    if (useCoefficient) params.append('useCoefficient', 'true');

    const response = await HttpNoData(
        `/api/v1/sendsanalyze/products/${timeSpan}?${params.toString()}`,
        'GET',
        jwt
    );

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}

export async function NewProductOnDateRange(timeSpan, startDate, endDate, jwt, placeIds = [], productType = null, useCoefficient = false) {
    const params = new URLSearchParams();
    params.append('start', startDate);
    params.append('end', endDate);

    placeIds.forEach(id => {
        params.append('placeIds', id.toString());
    });
    if (productType !== null) params.append('productType', productType);
    if (useCoefficient) params.append('useCoefficient', 'true');

    const response = await HttpNoData(
        `/api/v1/sendsanalyze/products/range/${timeSpan}?${params.toString()}`,
        'GET',
        jwt
    );

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}

export async function getNewPlaces(jwt) {
    const response = await HttpNoData('/api/v1/sendsanalyze/places', 'GET', jwt);

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}
